import React from 'react';
import { Menu } from 'antd';

import { Logo } from 'components';

import useSidebarBodyHeight from './hooks/useSidebarBodyHeight';

import { ISidebarProps } from './Sidebar.types';

import './Sidebar.styles.scss';

const Sidebar = ({ active, className = '', menuProps = {}, menuFooter, ...props }: ISidebarProps) => {
  const { defaultOpenKeys, items = [], ...otherMenuProps } = menuProps;

  const selectedKeys = Array.isArray(active) ? active : [active];
  const openKeys = Array.isArray(defaultOpenKeys) ? defaultOpenKeys : [defaultOpenKeys];

  const { headerRef, menuFooterRef, bodyHeight } = useSidebarBodyHeight();

  const emptyBodyClass = items.length ? '' : 'np-sidebar__body--empty';
  const emptyMenuFooterClass = items.length ? '' : 'np-sidebar__menu-footer--empty';

  return (
    <div className={`np-sidebar ${className}`} {...props}>
      <div>
        <div ref={headerRef} className="np-sidebar__header">
          <Logo />
        </div>

        <div style={{ height: bodyHeight }} className={`np-sidebar__body ${emptyBodyClass}`}>
          <Menu
            mode="inline"
            selectedKeys={selectedKeys}
            defaultOpenKeys={openKeys}
            items={items}
            {...otherMenuProps}
          />
        </div>

        {menuFooter && (
          <div ref={menuFooterRef} className={`np-sidebar__menu-footer ${emptyMenuFooterClass}`}>
            {menuFooter}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
